/**
 * A programme's two names must each be its own — `SaveProgramBasicInfoHandler` refuses an
 * Arabic name another programme holds in Arabic, or an English one held in English, trimmed
 * and in any case (SQL Server's collation). It says so only when the last step is saved, and
 * without naming the field (Taiga #1530); these let step 1 say it, on the field.
 */

const key = (value) => String(value ?? '').trim().toLowerCase()

/** The names the OTHER programmes hold — the one being edited does not clash with itself. */
export function takenNames(programs, ownId) {
  const others = (programs ?? []).filter((program) => String(program.id) !== String(ownId ?? ''))
  return {
    arabic: new Set(others.map((program) => key(program.arabicName)).filter(Boolean)),
    english: new Set(others.map((program) => key(program.englishName)).filter(Boolean)),
  }
}

/** `{ arabicName?, englishName? }` — the message on each field whose name is already held. */
export function nameClashes(values, taken, message) {
  const clashes = {}
  if (!taken) return clashes
  if (taken.arabic.has(key(values.arabicName))) clashes.arabicName = message
  if (taken.english.has(key(values.englishName))) clashes.englishName = message
  return clashes
}
